import { render, staticRenderFns } from "./SignerSettings.vue?vue&type=template&id=79250c80&"
import script from "./SignerSettings.vue?vue&type=script&lang=js&"
export * from "./SignerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports